import { ChatType } from './chat_view';
import Utility from "../../../../utility/utility";
import EventManager from "../../../../manager/event_manager";
import { Notify } from "../../server/notify/proto_notify";
import ModelData, { IUserData } from "../../../public/model_data";
import ViewBase from '../../../../framework/core/mvvm/view_base';
import GameUtil from '../../../../utility/game_util';
import UserDataManager from '../../../../manager/user_manager';

// Learn TypeScript:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/typescript.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/reference/attributes.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - [Chinese] https://docs.cocos.com/creator/manual/zh/scripting/life-cycle-callbacks.html
//  - [English] http://www.cocos2d-x.org/docs/creator/manual/en/scripting/life-cycle-callbacks.html

const { ccclass, property } = cc._decorator;

@ccclass
export default class ChatItem extends ViewBase {




  @property(cc.RichText)
  myTalkTxt: cc.RichText = null;

  @property(cc.RichText)
  otherTalkTxt: cc.RichText = null;

  @property(cc.Sprite)
  myIcon: cc.Sprite = null;

  @property(cc.Sprite)
  otherIcon: cc.Sprite = null;

  @property(cc.Node)
  myNode: cc.Node = null;

  @property(cc.Node)
  otherNode: cc.Node = null;

  @property(cc.Label)
  myNameTxt: cc.Label = null;

  @property(cc.Label)
  otherNameTxt: cc.Label = null;

  // @property(cc.RichText)
  // anwerTxt: cc.RichText = null;

  // @property(cc.Node)
  // talkBg: cc.Node = null;

  itemId = 0
  index = 0;
  limitLen = 26
  offset = 80
  nodeHeight = 0
  showTxt: string = ""
  worldData: Notify.GroupChatMessage.IGroupChatContent = null;
  friendData: Notify.ChatMessage = null
  playerNameStr = ""
  playerAvatar = ""
  content = ""
  curType = -1
  // LIFE-CYCLE CALLBACKS:

  // onLoad () {}

  start() {

  }
  setData(type: ChatType, i, data: any) {
    this.curType = type
    this.index = i
    this.worldData = null
    this.friendData = null
    this.nodeHeight = 0
    if (type == ChatType.friendChat) //私聊
    {
      this.friendData = <Notify.ChatMessage>data
      let jsonStr = JSON.parse(this.friendData.content)
      this.playerAvatar = jsonStr.avatar
      this.playerNameStr = jsonStr.nickName
      this.content = jsonStr.content;
      this.checkFriendData()
    }
    else if (type == ChatType.worldChat) //世界
    {
      this.worldData = <Notify.GroupChatMessage.IGroupChatContent>data
      this.checkWorldData()
    }
    else //系统
    {
      this.myNode.active = false
      this.otherNode.active = true
      this.content = <string>data
      this.showOtherNode()
    }
  }
  checkWorldData() {
    this.myNode.active = this.worldData.userId == ModelData.instance.roleData.id
    this.otherNode.active = !this.myNode.active
    if (this.worldData.userId == ModelData.instance.roleData.id) {
      this.showMyNode(this.worldData.content, this.worldData.avatar)
    }
    else {
      this.showOtherNode()
    }
  }
  checkFriendData() {

    this.myNode.active = this.friendData.sendUserId == ModelData.instance.roleData.id
    this.otherNode.active = !this.myNode.active

    if (this.friendData.sendUserId == ModelData.instance.roleData.id) {
      this.showMyNode(this.content, this.playerAvatar)
    }
    else {
      this.showOtherNode()
    }
  }

  showMyNode(content: string, avatar: string) {

    let txt = this.checkTxt(content)
    this.myTalkTxt.string = txt
    this.showTxt = txt;

    this.nodeHeight = this.myTalkTxt.node.getContentSize().height
    this.myNameTxt.string = ModelData.instance.roleData.name
    let self = this
    UserDataManager.getAvatarSprite(avatar, function (SpriteFrame) {
      self.myIcon.spriteFrame = SpriteFrame
    })
    this.node.height = this.nodeHeight + this.offset;
  }
  showOtherNode() {

    let txt: string = ""

    if (this.curType == ChatType.worldChat) {
      this.otherNameTxt.string = this.worldData.nickName
      txt = this.checkTxt(this.worldData.content)
      this.otherTalkTxt.string = txt
      this.showTxt = txt

      let self = this
      UserDataManager.getAvatarSprite(this.worldData.avatar, function (SpriteFrame) {
        self.otherIcon.spriteFrame = SpriteFrame
      })
    }
    else if (this.curType == ChatType.friendChat) {
      this.otherNameTxt.string = this.playerNameStr
      txt = this.checkTxt(this.content)
      this.otherTalkTxt.string = txt
      this.showTxt = txt

      let self = this
      UserDataManager.getAvatarSprite(this.playerAvatar, function (SpriteFrame) {
        self.otherIcon.spriteFrame = SpriteFrame
      })
    }
    else if (this.curType == ChatType.system) {
      txt = this.checkTxt(this.content)
      this.otherTalkTxt.string = txt
      this.showTxt = txt
    }
    this.nodeHeight = this.otherTalkTxt.node.getContentSize().height
    this.node.height = this.nodeHeight + this.offset




  }
  checkTxt(txt: string) {
    if (txt.length <= this.limitLen) {
      return txt
    }
    let num = Math.floor(txt.length / this.limitLen) + 1
    let tempTxt: string = ""
    let returnTxt: string = ""
    for (let i = 0; i < num; i++) {
      tempTxt = txt.substring(i * this.limitLen, (i * this.limitLen) + this.limitLen)
      if (i != num - 1) {
        tempTxt += "\n"
        // this.offset+=30
      }
      returnTxt += tempTxt
    }

    return returnTxt
  }
}
